import { Anchor, Breadcrumbs, Card, Grid, Text } from '@mantine/core';
import { useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import Spinner from '../../components/Spinner';
import TemplatesDetailsForm from '../../components/Templates/TemplatesDetailsForm';
import useTemplate from '../../components/Templates/useTemplate';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['template']}`;

const TemplatesDetailsPage = () => {
  const navigate = useNavigate();
  const fetch = useFetch();
  const location = useLocation();

  const [loadError, setLoadError] = useState();
  const { accountId, domainId, templateId } = useParams();
  const template = useTemplate(accountId, domainId, templateId);

  const del = (cb) => {
    return fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/templates/${template.id}`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        navigate(location.pathname.replace(`/templates/${template.id}/details`, `/templates`));
      })
      .catch(setLoadError);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (template === undefined) {
    return <Spinner />;
  }

  if (template === null) {
    navigate(`/accounts/${accountId}/domains/${domainId}/templates`);
    return;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/templates` },
    { title: template.name },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | ${template.name} | Details`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <Grid>
        <Grid.Col span={12}>
          <Card withBorder>
            <TemplatesDetailsForm
              template={template}
              onSuccess={() => navigate(`/accounts/${accountId}/domains/${domainId}/templates`)}
              onBack={() => navigate(-1)}
              del={del}
            />
          </Card>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default TemplatesDetailsPage;
